<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import {
    messageAlertDisconnectEmptyHappy,
    messageAlertDisconnectHappy
} from '@/happyTheme/event/messageDisconnect/messageAlertDisconnectHappy'

function toggleAlertMessageDisconnectHappy() {
    messageAlertDisconnectHappy.value = messageAlertDisconnectEmptyHappy
}
</script>

<template>
    <section class="section-modal-message-disconnect-happy">
        <section
            class="section-overlay-message-disconnect-happy"
            @click="toggleAlertMessageDisconnectHappy"
        ></section>

        <section class="section-message-disconnect-happy">
            <div
                class="div-content-message-disconnect-happy"
                :class="`div-content-message-disconnect-happy-${messageAlertDisconnectHappy.class}`"
            >
                <ButtonClose
                    :function="toggleAlertMessageDisconnectHappy"
                    :hover-color="
                        messageAlertDisconnectHappy.class === 'success'
                            ? 'success-happy'
                            : 'error-happy'
                    "
                />
            </div>

            <div
                class="div-second-content-message-disconnect-happy"
                :class="messageAlertDisconnectHappy.class"
            >
                <p>{{ messageAlertDisconnectHappy.message }}</p>
            </div>
        </section>
    </section>
</template>

<style scoped>
.section-modal-message-disconnect-happy {
    @apply fixed z-30 w-full h-full flex justify-center;
}

.section-overlay-message-disconnect-happy {
    @apply w-full h-full;
}

.section-message-disconnect-happy {
    @apply z-10 absolute w-72  flex flex-col justify-center mt-52;
}

.div-content-message-disconnect-happy {
    @apply w-full h-full rounded-t-md p-2 bg-green-light-happy flex justify-end;
}

.div-second-content-message-disconnect-happy {
    @apply w-full h-full rounded-b-md pt-3 p-2 text-center;
}

.div-content-message-disconnect-happy-success {
    @apply bg-green-light-happy;
}
.div-content-message-disconnect-happy-error {
    @apply bg-header-red-happy;
}
.success {
    @apply bg-green-happy text-text-dark-happy-light font-semibold;
}
.error {
    @apply bg-border-red-happy-light text-bg-happy-light font-semibold;
}
</style>
